import { saveAs } from 'file-saver';

const exportTxt = async (data, name) => {
  saveAs(new Blob(['', data], { type: 'text/plain; charset=utf-8' }), `${name}.txt`);
};

export default exportTxt;
